const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    close: "Close",
    back: "Back",
    next: "Next",
    loading: "Loading...",
    saving: "Saving...",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    all: "All",
    none: "None",
    error: "Error",
    success: "Success",
    refresh: "Refresh",
    logout: "Log out",
    dashboard: "Dashboard",
    settings: "Settings",
    profile: "Profile",
    today: "Today",
    noData: "No data",
    copied: "Copied",
    required: "Required",
    optional: "Optional",
    minutes: "minutes",
    search: "Search",
  },
  auth: {
    welcome: "Welcome",
    loginSubtitle: "Log in to your EVA AI account",
    email: "Email",
    password: "Password",
    login: "Log in",
    loggingIn: "Logging in...",
    forgotPassword: "Forgot password?",
    forgotPasswordTitle: "Forgot Password?",
    forgotPasswordDesc: "Enter your email to receive a reset link",
    enterEmail: "Please enter your email",
    resetLinkSent: "If the email exists, you will receive a reset link",
    resetLinkSentLong: "If the email exists in our system, you will receive a reset link within a few minutes. Check your spam folder too.",
    sendError: "Error sending",
    sending: "Sending...",
    sendResetLink: "Send Reset Link",
    backToLogin: "Back to Login",
    setNewPassword: "Set New Password",
    setNewPasswordDesc: "Enter your new password",
    passwordResetSuccess: "Password reset successfully!",
    tokenInvalid: "Invalid or expired token",
    invalidLink: "Invalid link. Please request a new reset link.",
    requestNewLink: "Request New Link",
    updating: "Updating...",
    noAccount: "Don't have an account?",
    signup: "Sign up",
    emailRequired: "Email and password are required",
    loginSuccess: "Login successful!",
    invalidCredentials: "Invalid credentials",
    signupTitle: "Create Account",
    signupSubtitle: "Register your EVA AI account",
    tenantName: "Studio/Business Name",
    confirmPassword: "Confirm Password",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters",
    allFieldsRequired: "All fields are required",
    signupSuccess: "Account created successfully!",
    signingUp: "Signing up...",
    hasAccount: "Already have an account?",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changePassword: "Update Password",
    changingPassword: "Updating...",
    passwordChanged: "Password updated",
    minChars: "Minimum 8 characters",
    wrongCurrentPassword: "Current password is incorrect",
    fillAllFields: "Fill in all fields",
  },
  verifyEmail: {
    title: "Verify your email",
    checking: "Verifying your email...",
    successTitle: "Email verified",
    successDesc: "Your email address has been verified successfully.",
    invalidTitle: "Verification failed",
    invalidDesc: "This verification link is invalid or expired. You can request a new one from the dashboard.",
    missingToken: "The verification token is missing from this link.",
    goToDashboard: "Go to dashboard",
    goToLogin: "Go to login",
    bannerTitle: "Verify your email",
    bannerDesc: "Verify your email so you can recover your account and receive important service notices.",
    resend: "Resend verification email",
    sending: "Sending...",
    sent: "Verification email sent. Check your inbox.",
    sendError: "Could not send the verification email. Try again later.",
  },

  dashboard: {
    completeSetup: "Complete Setup",
    activateSubscription: "Activate your subscription to use EVA AI.",
    configureWhatsApp: "Configure WhatsApp to start receiving messages.",
    startSetup: "Start Setup",
    subscription: "Subscription",
    founderPlan: "Founder plan with full access",
    monthlyActive: "99 CHF/month - Active",
    setupRequired: "Setup required",
    activateBtn: "Activate Subscription",
    whatsapp: "WhatsApp",
    phoneNumber: "Number",
    notSpecified: "Not specified",
    notConfigured: "No configuration present",
    configure: "Configure",
    messages: "Messages",
    lastMessages: "Last messages received",
    evaStatus: "EVA Status",
    evaActive: "Eva Active",
    evaPaused: "Eva Paused",
    autoResponses: "Automatic responses",
    quickPause: "Quick pause",
    pausedFor: "Eva paused for {minutes} minutes",
    evaReactivated: "Eva reactivated",
    languageControl: "Language Control",
    languageControlDesc: "Set default language and force for all contacts",
    defaultLanguage: "Default Language",
    forceLanguage: "Force Global Language",
    forceLanguageOn: "All contacts will receive responses in this language",
    forceLanguageOff: "Eva detects language automatically",
    saveLanguage: "Save Language Control",
    languageSaved: "Language control saved",
    quickActions: "Quick Actions",
    openInbox: "Open Inbox",
    calendar: "Calendar",
    setupWizard: "Setup Wizard",
    refreshData: "Refresh Data",
    recentMessages: "Recent Messages",
    recentMessagesDesc: "Last 10 messages received",
    noMessages: "No messages yet",
    noMessagesHint: "Messages will appear here when you start receiving requests",
    contact: "Contact",
    direction: "Direction",
    message: "Message",
    language: "Language",
    date: "Date",
    received: "Received",
    sent: "Sent",
    subscriptionActivated: "Subscription activated",
    checkoutReceived: "Checkout received, checking...",
    dataLoadError: "Error loading data",
    statusUpdateError: "Error updating status",
    pauseError: "Error pausing",
    languageSaveError: "Error saving",
    contactLanguageUpdated: "Contact language updated",
    contactLanguageError: "Error updating",
    active: "Active",
    pastDue: "Past Due",
    canceled: "Canceled",
    incomplete: "Incomplete",
    connected: "Connected",
  },
  calendar: {
    title: "Appointment Calendar",
    confirmed: "confirmed",
    pending: "pending",
    blocked: "blocked",
    arriving: "arriving",
    noAppointments: "No appointments",
    noAppointmentsDay: "No appointments for this day",
    newAppointment: "New",
    blockSlot: "Block",
    girlFilter: "Girl",
    statusFilter: "Status",
    allGirls: "All",
    activeFilter: "Active",
    confirmedFilter: "Confirmed",
    pendingFilter: "Pending",
    blockedFilter: "Blocked",
    completedFilter: "Completed",
    appointmentDetail: "Appointment Detail",
    blockedSlot: "Blocked Slot",
    girl: "Girl",
    dateLabel: "Date",
    time: "Time",
    duration: "Duration",
    whatsappLabel: "WhatsApp",
    buzzer: "Buzzer",
    notes: "Notes",
    dateTime: "Date/Time",
    status: "Status",
    arrivalStatus: "Arrival Status",
    noChanges: "No changes",
    appointmentUpdated: "Appointment updated",
    deleted: "Deleted",
    newAppointmentTitle: "New Appointment",
    girlRequired: "Girl and date/time are required",
    appointmentCreated: "Appointment created",
    clientPhone: "Client WhatsApp",
    languageOptional: "Language",
    buzzerOptional: "Buzzer",
    createAppointment: "Create Appointment",
    creating: "Creating...",
    blockSlotTitle: "Block Slot",
    blockDuration: "Duration",
    blockReason: "Reason / Notes",
    blockReasonPlaceholder: "E.g.: Break, unavailable, etc.",
    blockSubmit: "Block Slot",
    blocking: "Blocking...",
    slotBlocked: "Slot blocked",
    loadError: "Error loading appointments",
    blocked_label: "BLOCKED",
  },
  settings: {
    title: "EVA AI - Settings",
    whatsappConfig: "WhatsApp Configuration",
    whatsappConfigDesc: "Manage WhatsApp Business API credentials",
    webhookUrl: "Webhook URL",
    phoneNumberId: "Phone Number ID",
    accessToken: "Access Token",
    accessTokenStored: "Token saved",
    accessTokenStoredHint: "The token is stored securely. You do not need to enter it again.",
    replaceAccessToken: "Replace token",
    replaceAccessTokenHint: "Enter a new token only if you want to replace the saved one.",
    accessTokenRequiredHint: "Enter the Meta token. After saving, it will remain stored securely.",
    verifyToken: "Verify Token",
    phoneNumber: "Phone Number",
    saveWhatsApp: "Save WhatsApp Configuration",
    whatsappSaved: "WhatsApp configuration saved",
    generalSettings: "General Settings",
    generalSettingsDesc: "Customize EVA AI behavior",
    defaultLanguage: "Default Language",
    forceLanguage: "Force Global Language",
    forceLanguageDesc: "Override automatic detection and always use this language",
    forcedLanguage: "Forced Language",
    durations: "Durations (minutes, comma-separated)",
    externalDetailsLink: "External Details Link (compliance)",
    pricingText: "Pricing Text",
    rules: "Rules",
    locationInfo: "Location Information",
    welcomeMessage: "Welcome Message",
    saveSettings: "Save Settings",
    settingsSaved: "Settings saved",
    studioConfig: "Studio Configuration",
    studioConfigDesc: "Public settings for info and bookings",
    studioName: "Studio Name",
    publicInfoUrl: "Official Link (Services/Prices/Girls)",
    publicInfoUrlWarning: "Without a valid link (http:// or https://) EVA cannot send the link for services/prices/girls. She will still respond warmly and guide toward booking, but without sharing the link.",
    publicInfoUrlHint: "This link will be used to respond to requests about services, prices and girls",
    girlsList: "Girls (one per line)",
    girlsListHint: "If more than one girl, EVA will ask for a choice. If only one, automatic selection.",
    saveStudio: "Save Studio Configuration",
    saveError: "Error saving",
    loadError: "Error loading data",
    urlCopied: "URL copied",
  },
  wizard: {
    title: "Setup EVA AI",
    stepOf: "Step {step} of {total}",
    billingTitle: "Subscription",
    billingDesc: "Activate your monthly subscription to use EVA AI",
    founderTitle: "Internal Plan (Founder)",
    founderDesc: "You have full access to all features without a subscription.",
    founderHint: "You can proceed directly to WhatsApp configuration.",
    subscriptionActive: "Subscription active! You can proceed with configuration.",
    standardPlan: "Standard Plan",
    standardPlanDesc: "All inclusive, no commitment",
    perMonth: "per month",
    featureWhatsApp: "WhatsApp Cloud API integration",
    featureMultilang: "Multilingual support (IT/DE/EN/ES)",
    featureBooking: "FSM booking engine",
    featureDashboard: "Dashboard and analytics",
    activateSubscription: "Activate Subscription",
    activating: "Opening Checkout...",
    stripeRedirect: "You will be redirected to Stripe to complete the payment securely.",
    privatePilotBilling: "EVA is in a private pilot: subscriptions and charges are disabled until the service opens for sale.",
    privatePilotClosed: "Payments closed during the pilot",
    whatsappTitle: "WhatsApp Configuration",
    whatsappDesc: "Connect your WhatsApp Business account",
    webhookUrl: "Webhook URL",
    phoneNumberId: "Phone Number ID",
    phoneNumberIdHint: "Find it in Meta Business Manager → WhatsApp → API Setup",
    accessToken: "Access Token",
    verifyToken: "Verify Token",
    verifyTokenHint: "Use this EVA-provided value when Meta asks for the webhook Verify Token. It is managed by EVA.",
    phoneNumber: "Phone Number",
    fillRequired: "Fill in all required fields",
    whatsappSaved: "WhatsApp configuration saved",
    settingsTitle: "Settings",
    settingsDesc: "Customize EVA AI behavior",
    defaultLanguage: "Default Language",
    durations: "Available Durations (minutes, comma-separated)",
    externalDetailsLink: "External Details Link (IMPORTANT for compliance)",
    externalDetailsHint: "EVA will redirect to this link when receiving media or explicit requests",
    pricingText: "Pricing Text",
    rules: "Rules",
    locationInfo: "Location Information",
    welcomeMessage: "Welcome Message",
    settingsSaved: "Settings saved",
    testTitle: "Test Message",
    testDesc: "Send a test message to verify the configuration",
    testAlmostDone: "Setup almost complete! Send a test message to confirm everything works.",
    recipient: "Recipient Number (international format, without +)",
    recipientHint: "E.g.: 41791234567 for a Swiss number",
    messageLabel: "Message",
    sendTest: "Send Test Message",
    sending: "Sending...",
    testSent: "Test message sent successfully!",
    testCheckPhone: "Check your phone to verify message reception",
    fillRecipient: "Enter number and message",
    completeSetup: "Complete Setup",
    setupComplete: "Setup complete!",
    checkoutError: "Error opening checkout",
  },
  account: {
    title: "EVA AI - Profile",
    subscription: "Subscription",
    subscriptionDesc: "Manage your plan and subscription",
    plan: "Plan",
    status: "Status",
    nextRenewal: "Next renewal",
    scheduledCancel: "Scheduled cancellation",
    cancelWarning: "The subscription will remain active until the end of the already paid period ({date}).",
    founderAlert: "Founder plan: unlimited access at no cost.",
    price: "Price",
    validUntil: "Valid until",
    scheduledCancelAlert: "Scheduled cancellation: The subscription will end at the end of the current period.",
    cancelSubscription: "Cancel Subscription (End of Period)",
    cancelConfirmTitle: "Confirm cancellation?",
    cancelConfirmDesc: "The cancellation will take effect at the end of the already paid period. The current month is non-refundable.",
    confirmCancel: "Confirm Cancellation",
    canceling: "Canceling...",
    cancelSuccess: "Cancellation scheduled",
    cancelError: "Error canceling",
    security: "Security",
    securityDesc: "Change your account password",
    active: "Active",
    pastDue: "Past Due",
    canceledStatus: "Canceled",
    incompleteStatus: "Incomplete",
    founderInternal: "Founder / Internal",
    standard: "Standard",
    yourData: "Your data",
    yourDataDesc: "Export your account data or request assisted deletion",
    dataLifecycleNotice: "The export excludes passwords, provider credentials and payment-card data. Deletion requests are verified and handled without unsupported deadline promises.",
    downloadData: "Download my data",
    dataExportSuccess: "Data export is ready",
    dataExportError: "Could not export data",
    requestDeletion: "Request account deletion",
    deletionConfirmTitle: "Request deletion?",
    deletionConfirmDesc: "The request will be recorded for operational verification. Subscription, legal obligations, third parties and backups must be handled before closure.",
    deletionConfirmationLabel: "Type DELETE MY EVA ACCOUNT",
    submitDeletionRequest: "Submit request",
    deletionRequestSuccess: "Deletion request recorded",
    deletionRequestError: "Could not record the request",
  },
  inbox: {
    title: "EVA AI - Inbox",
    conversations: "Conversations",
    noConversations: "No conversations",
    noConversationsHint: "Conversations will appear here when you receive messages",
    messagesLabel: "messages",
    lastActivity: "last activity",
    typeMessage: "Type a message...",
    send: "Send",
    selectConversation: "Select a conversation",
    selectConversationHint: "Choose a conversation from the list to see messages",
    messageSent: "Message sent",
    messageSendError: "Error sending message",
    loadError: "Error loading conversations",
    messagesLoadError: "Error loading messages",
    eva: "EVA",
    client: "Client",
    manualMode: "Manual",
    manualModeActive: "Manual mode active. Eva won't respond automatically.",
    manualModeActivated: "Manual mode activated",
    evaReactivated: "Eva reactivated",
    modeChangeError: "Error changing mode",
    noMessages: "No messages",
    active: "Active",
    optedOut: "Opted out",
    now: "Now",
    minutesAgo: "{n}m ago",
    hoursAgo: "{n}h ago",
    unreadNew: "new",
    unreadNewPlural: "new",
    contacts: "contacts",
    contact: "contact",
  },
  languages: {
    it: "Italian",
    de: "German",
    en: "English",
    es: "Spanish",
    auto: "Auto",
  },
  signup: {
    title: "Create Your Account",
    subtitle: "Start using EVA AI in just a few minutes",
    button: "Create Account",
    creating: "Creating...",
    termsAccept: "By creating an account you accept our",
    termsOfService: "Terms of Service",
    and: "and the",
    privacyPolicy: "Privacy Policy",
    legalConsentPrefix: 'I accept the',
    legalConsentAndPrivacy: 'and confirm that I have read the',
    legalRequired: 'Accept the current Terms, DPA and Privacy Policy acknowledgement to create the account.',
    legalUnavailable: 'Legal information is temporarily unavailable. Reload the page before signing up.',
    nonCommercialLegal: 'This environment is not yet configured for commercial use; legal details are incomplete.',
    privatePilotTitle: "Private invite-only pilot",
    privatePilotDesc: "New registrations and payments are temporarily closed. Previously invited users can continue to sign in and test EVA.",
    privatePilotLogin: "Sign in to the pilot",
  },
  uiLanguage: {
    label: "Interface language",
    selectorTitle: "Language",
  },
  landing: {
    login: "Log in",
    startNow: "Get started",
    heroTitle1: "The WhatsApp Assistant",
    heroTitle2: "for your studio bookings",
    heroSubtitle: "Automate bookings, client requests and appointment management via WhatsApp with EVA AI. Multilingual, compliant and ready in minutes.",
    heroCta: "Get started",
    learnMore: "Learn more",
    featuresTitle: "Key Features",
    featuresSubtitle: "Everything you need to manage bookings and client requests via WhatsApp",
    feature1Title: "WhatsApp Automation",
    feature1Desc: "Automated booking assistant for appointments and client requests via WhatsApp.",
    feature2Title: "Multilingual Support",
    feature2Desc: "Italian, German, English and Spanish with consistent language handling.",
    feature3Title: "Smart Booking Engine",
    feature3Desc: "Understands natural language requests and manages bookings with date, time and duration reliably.",
    feature4Title: "Built-in Compliance",
    feature4Desc: "STOP/START management, media redirect and sensitive content control.",
    pricingTitle: "Simple, Clear Pricing",
    pricingSubtitle: "One plan, everything included",
    planName: "Standard Plan",
    planPeriod: "per month, no commitment",
    bullet1: "WhatsApp Cloud API integration",
    bullet2: "Multilingual support (IT/DE/EN/ES)",
    bullet3: "Smart booking engine",
    bullet4: "Dashboard and analytics",
    bullet5: "GDPR/FADP compliance",
    privacy: "Privacy",
    terms: "Terms",
    dpa: "DPA",
  },
  alerts: {
    bookingCreated: "New Booking",
    bookingUpdated: "Booking Updated",
    bookingCancelled: "Booking Cancelled",
    customerArrival: "Customer Arriving",
    manualModeMessage: "Message (EVA off)",
    girl: "Girl",
    time: "Time",
    duration: "Duration",
    client: "Client",
    source: "Source",
    whatsapp: "WhatsApp",
    manual: "Manual",
    changed: "Changed",
    unknown: "Unknown",
    phone: "Phone",
    arrivalHelp: "Arrival help",
    soundOn: "Alert sound ON",
    soundOff: "Alert sound OFF",
    noAlerts: "No recent alerts",
    recentAlerts: "Recent Alerts",
    clearAll: "Clear all",
    dismiss: "Dismiss",
    viewCalendar: "Calendar",
    viewInbox: "Inbox",
    min: "min",
    arrivalIncoming: "incoming",
    arrivalOutside: "on site",
    arrivalAtDoor: "at the door",
    arrivalArrived: "arrived",
  },
};

export default en;
